import { SET_CONTENT } from 'constants/actionTypes/content';
import { SET_NEW_PRODUCTS_PAGE, SET_BESTSELLER_PRODUCTS_PAGE } from 'constants/actionTypes/storeAggregation';

const initialState = {};

const reducer = function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_CONTENT: {
            const { data } = payload;

            return data;
        }

        case SET_NEW_PRODUCTS_PAGE:
        case SET_BESTSELLER_PRODUCTS_PAGE: {
            const { currentPage, ...restPayload } = payload;

            // Append newly fetched items to the existing list
            // when additional items are loaded through the "Show More Products" button
            const items = currentPage > 1 ? [...(state?.sasData?.items || []), ...restPayload.items] : restPayload.items;
            const lastFetchedItemsCount = restPayload.items?.length;

            const nextState = {
                ...state,
                sasData: {
                    isSasInitialized: true,
                    ...restPayload,
                    items,
                    lastFetchedItemsCount
                }
            };

            return nextState;
        }
        default: {
            return state;
        }
    }
};

export default reducer;
